var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardOverviewCrashtrendIcon = function SvgNewcsDashboardOverviewCrashtrendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_overview_crashtrend_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M676 100h18v18h-18z",
    "data-name": "\\u77E9\\u5F62 1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_overview_crashtrend_icon_svg__a)",
    transform: "translate(-676 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M683.985 112.857a.87.87 0 0 1-.853-.7l-1.389-6.806-1 2.931a.87.87 0 0 1-.824.59h-3.048a.871.871 0 1 1 0-1.742h2.429l1.832-5.383a.871.871 0 0 1 1.678.106l1.649 8.082 1.887-2.464a.871.871 0 1 1 1.516.249l.815 2.4h4.457a.871.871 0 0 1 0 1.742h-5.084a.87.87 0 0 1-.825-.59l-.491-1.443-2.057 2.688a.87.87 0 0 1-.692.341Zm9.146 3.983h-16.26a.871.871 0 1 1 0-1.742h16.26a.871.871 0 0 1 0 1.742",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardOverviewCrashtrendIcon;